export default __webpack_public_path__ + "static/design-illu-b459813fa589563eb5678830e3a0f249.png";